module.exports = __webpack_public_path__ + "590bc87be53b215d675ad2e63c13e5d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic16.png
// module id = 1860
// module chunks = 0